import React from 'react'
import styled from 'styled-components'
import gun from '../assets/rifles.jpg'

const Container = styled.div`
    display:flex;
    overflow:hidden;
    background-color:#111111;
    width:100vw;
    height:60vh;
   
    align-items:center;
    margin-top:100px;
   
`;
const Image = styled.img`
 
    height:60vh;
    width:40vw;
`
const H = styled.h1`
    flex:1;
    color:red;
    text-align:center;
`;
const P = styled.p`
    flex:2;
    color:white;
    font-size:20px;
    text-align:center;
`;
const About1 = () => {
  return (
    <Container>
        <Image src={gun}></Image>
        <H>Established in <span style={{color:'white'}}>2022.</span></H>
        <P>Tactical Bazaar is an online legal platform that provides door-to-door services to people interested in buying firearms and related products. Our team is dedicated to providing top-notch customer service and taking the time to listen to your specific needs and concerns. We understand that purchasing a firearm is a significant investment of both time and money, and we are here to help you make the best decision for the protection of yourself and your loved ones. We value our customers and their trust in us, and we are committed to providing the highest quality products and services to meet their needs.</P>
    </Container>

  )
}

export default About1